function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m12 15c-.276 0-.5-.224-.5-.5v-.751c0-.276.224-.5.5-.5s.5.224.5.5v.751c0 .276-.224.5-.5.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m12.25 14h-1.75c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.75c.414 0 .75-.337.75-.75s-.336-.75-.75-.75h-.5c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75h1.75c.276 0 .5.224.5.5s-.224.5-.5.5h-1.75c-.414 0-.75.337-.75.75s.336.75.75.75h.5c.965 0 1.75.785 1.75 1.75s-.785 1.75-1.75 1.75z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m12 8.751c-.276 0-.5-.224-.5-.5v-.751c0-.276.224-.5.5-.5s.5.224.5.5v.751c0 .276-.224.5-.5.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m12 17c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm0-11c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m12 22c-.276 0-.5-.224-.5-.5s.224-.5.5-.5c5.514 0 10-4.486 10-10 0-.276.224-.5.5-.5s.5.224.5.5c0 6.065-4.935 11-11 11z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m21.91 8.05c-.207 0-.401-.13-.473-.336-1.39-4.016-5.183-6.714-9.437-6.714-2.276 0-4.408.747-6.167 2.159-.215.172-.53.139-.703-.076-.173-.216-.138-.53.077-.703 1.938-1.557 4.287-2.38 6.793-2.38 4.68 0 8.853 2.969 10.383 7.386.09.262-.048.546-.309.637-.054.018-.11.027-.164.027z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m8.5 21.39c-.055 0-.111-.009-.166-.028-4.386-1.538-7.334-5.702-7.334-10.362 0-2.22.66-4.351 1.908-6.163.156-.229.467-.284.695-.129.228.157.285.468.128.695-1.132 1.646-1.731 3.581-1.731 5.597 0 4.236 2.679 8.021 6.666 9.418.26.091.397.376.306.637-.072.206-.265.335-.472.335z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m13.5 24c-.128 0-.256-.049-.354-.146l-2-2c-.195-.195-.195-.512 0-.707l2-2c.195-.195.512-.195.707 0s.195.512 0 .707l-1.646 1.646 1.646 1.646c.195.195.195.512 0 .707-.097.098-.225.147-.353.147z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m4.174 8c-.221 0-.423-.147-.483-.37l-.647-2.415-2.415.647c-.266.067-.541-.087-.612-.354s.087-.54.354-.612l2.898-.776c.267-.067.541.087.612.353l.776 2.897c.072.268-.087.541-.353.613-.044.011-.087.017-.13.017z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m22 8.598c-.085 0-.171-.021-.25-.067l-2.598-1.5c-.239-.138-.321-.443-.183-.683.138-.239.443-.322.683-.183l2.165 1.25 1.25-2.165c.138-.239.444-.322.683-.183.239.138.321.443.183.683l-1.5 2.598c-.093.16-.261.25-.433.25z"
});

const SvgTransfer = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_px",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransfer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transfer.3b990786.svg";
export { ForwardRef as ReactComponent };